(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div id=\"portalOneContainer\"></div>\n<div id=\"app-container\">\n  <div class=\"title\">\n    <img src=\"/assets/THIG-Logo.png\" alt=\"Tower Hill Insurance\">\n  </div>\n  <div class=\"container\">\n    <app-alert></app-alert>\n  </div>\n  <div class=\"container\">\n    <router-outlet></router-outlet>\n  </div>\n  <div *ngIf=\"showLoader\" class=\"custom-loading\">\n        <div class=\"spinner-container\">\n            <div class=\"spinner-text\">Loading...</div>\n            <mat-spinner></mat-spinner>\n        </div>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/billing-form/billing-form.component.html":
/*!************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/billing-form/billing-form.component.html ***!
  \************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"title\">\n  <mat-icon>person</mat-icon>\n  <span class=\"title-text\">Bill To</span>\n</div>\n<table class=\"selection-table\" mat-table [dataSource]=\"billingOptions.billees\">\n  <ng-container matColumnDef=\"select\">\n    <th mat-header-cell *matHeaderCellDef></th>\n    <td mat-cell *matCellDef=\"let row\">\n      <mat-radio-button name=\"billeeRadio\"\n                        (click)=\"$event.stopPropagation()\"\n                        (change)=\"onBilleeChange(row)\"\n                        [checked]=\"billeeSelection.isSelected(row)\">\n      </mat-radio-button>\n    </td>\n  </ng-container>\n  <ng-container matColumnDef=\"name\">\n    <th mat-header-cell *matHeaderCellDef> Name</th>\n    <td mat-cell *matCellDef=\"let billee\"> {{billee.name}} </td>\n  </ng-container>\n  <ng-container matColumnDef=\"type\">\n    <th mat-header-cell *matHeaderCellDef> Type</th>\n    <td mat-cell *matCellDef=\"let billee\"> {{billee.type}} </td>\n  </ng-container>\n  <ng-container matColumnDef=\"address\">\n    <th mat-header-cell *matHeaderCellDef> Address</th>\n    <td mat-cell *matCellDef=\"let billee\"> {{billee.address}} </td>\n  </ng-container>\n  <tr mat-header-row *matHeaderRowDef=\"billeeColumns\" class=\"selection-table-header-row\"></tr>\n  <tr mat-row *matRowDef=\"let row; columns: billeeColumns;\"\n      class=\"selection-table-row\"\n      (click)=\"onBilleeChange(row)\"></tr>\n</table>\n<div class=\"title\">\n  <mat-icon>payment</mat-icon>\n  <span class=\"title-text\">Payment Plan</span>\n</div>\n<table #paymentPlanTable class=\"selection-table\" mat-table [dataSource]=\"billingOptions.paymentPlans\">\n  <ng-container matColumnDef=\"select\">\n    <th mat-header-cell *matHeaderCellDef></th>\n    <td mat-cell *matCellDef=\"let row\">\n      <mat-radio-button name=\"paymentPlanRadio\"\n                        (click)=\"$event.stopPropagation()\"\n                        (change)=\"onPaymentPlanChange(row)\"\n                        [checked]=\"paymentPlanSelection.isSelected(row)\"\n                        [disabled]=\"isDisabled(row)\">\n      </mat-radio-button>\n    </td>\n  </ng-container>\n  <ng-container matColumnDef=\"name\">\n    <th mat-header-cell *matHeaderCellDef> Pay Plan</th>\n    <td mat-cell *matCellDef=\"let paymentPlan\"> {{paymentPlan.name}} </td>\n  </ng-container>\n  <ng-container matColumnDef=\"description\">\n    <th mat-header-cell *matHeaderCellDef> Description</th>\n    <td mat-cell *matCellDef=\"let paymentPlan\"> {{paymentPlan.description}} </td>\n  </ng-container>\n  <ng-container matColumnDef=\"downPayment\">\n    <th mat-header-cell *matHeaderCellDef> Down Payment</th>\n    <td mat-cell *matCellDef=\"let paymentPlan\"> {{paymentPlan.downPayment | currency}} </td>\n  </ng-container>\n  <ng-container matColumnDef=\"installment\">\n    <th mat-header-cell *matHeaderCellDef> Installment</th>\n    <td mat-cell *matCellDef=\"let paymentPlan\"> {{paymentPlan.installment | currency}} </td>\n  </ng-container>\n  <ng-container matColumnDef=\"numberOfInstallments\">\n    <th mat-header-cell *matHeaderCellDef> # Install.</th>\n    <td mat-cell *matCellDef=\"let paymentPlan\"> {{paymentPlan.numberOfInstallments}} </td>\n  </ng-container>\n  <ng-container matColumnDef=\"installFee\">\n    <th mat-header-cell *matHeaderCellDef> Per Install. Fee</th>\n    <td mat-cell *matCellDef=\"let paymentPlan\"> {{paymentPlan.installFee | currency}} </td>\n  </ng-container>\n  <ng-container matColumnDef=\"netDue\">\n    <th mat-header-cell *matHeaderCellDef> Net Due</th>\n    <td mat-cell *matCellDef=\"let paymentPlan\"> {{paymentPlan.netDue | currency}} </td>\n  </ng-container>\n  <tr mat-header-row *matHeaderRowDef=\"paymentPlanColumns\" class=\"selection-table-header-row\"></tr>\n  <tr mat-row *matRowDef=\"let row; columns: paymentPlanColumns\"\n      class=\"selection-table-row\"\n      [class.selection-table-row-disabled]=\"isDisabled(row)\"\n      (click)=\"onPaymentPlanChange(row)\"></tr>\n</table>\n<div id=\"button-row\">\n  <span id=\"button-spacer\"></span>\n  <button class=\"submit-button\"\n          mat-raised-button\n          color=\"primary\"\n          routerLink=\"/payment\"\n          [disabled]=\"!canSubmitWithPayment\">\n    Submit with Payment\n  </button>\n  <button class=\"submit-button\"\n          mat-raised-button\n          color=\"primary\"\n          (click)=\"submitWithoutPayment()\"\n          [disabled]=\"!canSubmitWithoutPayment\">\n    Submit without Payment\n  </button>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/alert/alert.component.html":
/*!***************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/core/alert/alert.component.html ***!
  \***************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div *ngFor=\"let alert of alerts\" class=\"alert {{ cssClass(alert) }}\">\n  <span class=\"message\">{{alert.message}}</span>\n  <span class=\"close-button\" (click)=\"removeAlert(alert)\"><mat-icon>close</mat-icon></span>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/error/error.component.html":
/*!**********************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/error/error.component.html ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div id=\"error-container\">\n  <mat-icon>error</mat-icon>\n  <span id=\"error-message\">{{ errorMessage }}</span>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/payment-form/payment-form.component.html":
/*!************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/payment-form/payment-form.component.html ***!
  \************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<form [formGroup]=\"paymentForm\">\n  <div class=\"payment-form-container\">\n    <div class=\"payment-amount-container\">\n      <div class=\"title\">\n        <mat-icon>attach_money</mat-icon>\n        <label id=\"payment-amount-label\" class=\"title-text\">Payment Amount</label>\n      </div>\n      <mat-radio-group aria-labelledby=\"payment-amount-label\"\n                       class=\"payment-amount-radio-group\"\n                       formControlName=\"paymentAmount\">\n        <mat-radio-button class=\"payment-amount-radio-button\" value=\"minimum\">\n          Pay Minimum Due - {{paymentPlan.downPayment | currency}}\n        </mat-radio-button>\n        <mat-radio-button class=\"payment-amount-radio-button\" value=\"balance\">\n          Pay Balance Due - {{paymentPlan.netDue | currency}}\n        </mat-radio-button>\n      </mat-radio-group>\n    </div>\n\n    <div class=\"payment-date-container\">\n      <mat-form-field color=\"accent\">\n        <input matInput [min]=\"minimumDate\" [max]=\"maximumDate\" [matDatepicker]=\"paymentDatePicker\"\n               placeholder=\"Payment Date\" formControlName=\"paymentDate\" required>\n        <mat-datepicker-toggle matSuffix [for]=\"paymentDatePicker\"></mat-datepicker-toggle>\n        <mat-datepicker #paymentDatePicker></mat-datepicker>\n      </mat-form-field>\n    </div>\n  </div>\n</form>\n<div class=\"payment-types\">\n  <div class=\"payment-type\">\n    <div class=\"payment-button\">\n      <button mat-raised-button color=\"primary\"\n              [disabled]=\"isButtonDisabled()\"\n              (click)=\"selectPaymentCategory('ECheck')\">\n        Checking or Savings Account\n      </button>\n    </div>\n    <div>Use your US based checking or savings account.</div>\n    <div>No processing fee.</div>\n  </div>\n  <div class=\"payment-type\">\n    <div class=\"payment-button\">\n      <button mat-raised-button color=\"primary\"\n              [disabled]=\"isButtonDisabled()\"\n              (click)=\"selectPaymentCategory('CreditCard')\">\n        Credit or Debit Card\n      </button>\n    </div>\n    <div>We accept all major credit and debit cards.</div>\n    <div>2.75% processing fee applies.</div>\n  </div>\n</div>\n<button mat-raised-button id=\"back-button\" routerLink=\"/billing\">\n  <mat-icon>chevron_left</mat-icon>\n  Back\n</button>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/payment-receipt/payment-receipt.component.html":
/*!******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/payment-receipt/payment-receipt.component.html ***!
  \******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div>\n  <div class=\"title\">\n    <mat-icon>receipt</mat-icon>\n    <span class=\"title-text\">Payment Receipt</span>\n  </div>\n  <div>\n    The below payment has been successfully submitted.\n  </div>\n  <mat-list>\n    <mat-list-item>\n      <span class=\"receipt-label\">Total Payment Amount</span>\n      <span class=\"receipt-value\">{{paymentDetails.totalPaymentAmount | currency}}</span>\n    </mat-list-item>\n    <mat-list-item>\n      <span class=\"receipt-label\">Payment Date</span>\n      <span class=\"receipt-value\">{{paymentDetails.paymentDate | date}}</span>\n    </mat-list-item>\n    <mat-list-item>\n      <span class=\"receipt-label\">Payment Type</span>\n      <span class=\"receipt-value\">{{paymentDetails.paymentCategory | uppercase}}</span>\n    </mat-list-item>\n    <mat-list-item>\n      <span class=\"receipt-label\">Confirmation Number</span>\n      <span class=\"receipt-value\">{{paymentDetails.confirmationNumber}}</span>\n    </mat-list-item>\n  </mat-list>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/payment-review/payment-review.component.html":
/*!****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/payment-review/payment-review.component.html ***!
  \****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div>\n  <div class=\"title\">\n    <mat-icon>assignment</mat-icon>\n    <span class=\"title-text\">Review &amp; Submit</span>\n  </div>\n  <mat-list>\n    <mat-list-item class=\"review-row\">\n      <span class=\"review-label\">Name on Account</span>\n      <span class=\"review-value\">{{paymentDetails.name}}</span>\n    </mat-list-item>\n    <mat-list-item class=\"review-row\" *ngIf=\"isEmailRequired()\">\n      <span class=\"review-label\">Email Address</span>\n      <mat-form-field class=\"email-value\">\n        <input matInput type=\"email\" required [value]=\"primaryInsuredEmailAddress\">\n      </mat-form-field>\n    </mat-list-item>\n    <mat-list-item class=\"review-row\" *ngIf=\"paymentDetails.paymentCategory === 'ECheck'\">\n      <span class=\"review-label\">Bank Name</span>\n      <span class=\"review-value\">{{paymentDetails.bankName}}</span>\n    </mat-list-item>\n    <mat-list-item class=\"review-row\" *ngIf=\"paymentDetails.paymentCategory === 'ECheck'\">\n      <span class=\"review-label\">Account Type</span>\n      <span class=\"review-value\">{{paymentDetails.accountType}}</span>\n    </mat-list-item>\n    <mat-list-item class=\"review-row\" *ngIf=\"paymentDetails.paymentCategory === 'ECheck'\">\n      <span class=\"review-label\">Routing Number (last four digits)</span>\n      <span class=\"review-value\">{{paymentDetails.lastFourDigits}}</span>\n    </mat-list-item>\n    <mat-list-item class=\"review-row\" *ngIf=\"paymentDetails.paymentCategory === 'CreditCard'\">\n      <span class=\"review-label\">Card Type</span>\n      <span class=\"review-value\">{{paymentDetails.cardType}}</span>\n    </mat-list-item>\n    <mat-list-item class=\"review-row\" *ngIf=\"paymentDetails.paymentCategory === 'CreditCard'\">\n      <span class=\"review-label\">Card Number (last four digits)</span>\n      <span class=\"review-value\">{{paymentDetails.lastFourDigits}}</span>\n    </mat-list-item>\n    <mat-list-item class=\"review-row\" *ngIf=\"paymentDetails.paymentCategory === 'CreditCard'\">\n      <span class=\"review-label\">Expiration Date</span>\n      <span class=\"review-value\">{{paymentDetails.cardExpirationMonth}}/{{paymentDetails.cardExpirationYear}}</span>\n    </mat-list-item>\n    <mat-list-item class=\"review-row\">\n      <span class=\"review-label\">Payment Amount</span>\n      <span class=\"review-value\">{{paymentDetails.amount | currency}}</span>\n    </mat-list-item>\n    <mat-list-item class=\"review-row\" *ngIf=\"paymentDetails.paymentCategory === 'CreditCard'\">\n      <span class=\"review-label\">Servicing Fee</span>\n      <span class=\"review-value\">{{paymentDetails.servicingFee | currency}}</span>\n    </mat-list-item>\n    <mat-list-item class=\"review-row\">\n      <span class=\"review-label\">Total Payment Amount</span>\n      <span class=\"review-value\">{{paymentDetails.totalPaymentAmount | currency}}</span>\n    </mat-list-item>\n    <mat-list-item class=\"review-row\">\n      <span class=\"review-label\">Payment Date</span>\n      <span class=\"review-value\">{{paymentDetails.paymentDate | date: 'MM/dd/yyyy'}}</span>\n    </mat-list-item>\n  </mat-list>\n  <div id=\"save-checkbox\">\n    <mat-checkbox [checked]=\"saveDetailChecked\">Save payment details</mat-checkbox>\n  </div>\n  <div id=\"save-payment-details\">\n    <mat-error>Unchecking this box will result in the payment details being\n      deleted following the processing of the payment on the above payment date.\n    </mat-error>\n  </div>\n  <mat-divider></mat-divider>\n  <div id=\"payment-notes\" *ngIf=\"paymentDetails.paymentCategory === 'ECheck'\">\n    If you are using a third-party check to make an electronic payment\n    (e.g., a home equity line of credit check or credit-card cash advance\n    check), it is necessary to first contact the financial institution and\n    verify that the check can be used for electronic payments prior to\n    submitting payment.\n  </div>\n</div>\n<div id=\"button-row\">\n  <span id=\"button-spacer\"></span>\n  <button class=\"submit-button\" mat-raised-button color=\"primary\" (click)=\"submitWithPayment()\">\n    Submit\n  </button>\n  <button class=\"back-button\" mat-raised-button routerLink=\"/payment\">\n    <mat-icon>chevron_left</mat-icon>\n    Back\n  </button>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/success/success.component.html":
/*!**************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/success/success.component.html ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"message\">\n    <mat-icon>check_circle</mat-icon>\n    <span class=\"message-text\">Policy successfully submitted.</span>\n</div>\n");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _billing_form_billing_form_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./billing-form/billing-form.component */ "./src/app/billing-form/billing-form.component.ts");
/* harmony import */ var _error_error_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./error/error.component */ "./src/app/error/error.component.ts");
/* harmony import */ var _payment_form_payment_form_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./payment-form/payment-form.component */ "./src/app/payment-form/payment-form.component.ts");
/* harmony import */ var _payment_receipt_payment_receipt_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./payment-receipt/payment-receipt.component */ "./src/app/payment-receipt/payment-receipt.component.ts");
/* harmony import */ var _payment_review_payment_review_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./payment-review/payment-review.component */ "./src/app/payment-review/payment-review.component.ts");
/* harmony import */ var _success_success_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./success/success.component */ "./src/app/success/success.component.ts");









const routes = [
    {
        path: '',
        redirectTo: 'billing',
        pathMatch: 'full'
    },
    {
        path: 'billing',
        component: _billing_form_billing_form_component__WEBPACK_IMPORTED_MODULE_3__["BillingFormComponent"]
    },
    {
        path: 'error',
        component: _error_error_component__WEBPACK_IMPORTED_MODULE_4__["ErrorComponent"]
    },
    {
        path: 'payment',
        component: _payment_form_payment_form_component__WEBPACK_IMPORTED_MODULE_5__["PaymentFormComponent"]
    },
    {
        path: 'review',
        component: _payment_review_payment_review_component__WEBPACK_IMPORTED_MODULE_7__["PaymentReviewComponent"]
    },
    {
        path: 'receipt',
        component: _payment_receipt_payment_receipt_component__WEBPACK_IMPORTED_MODULE_6__["PaymentReceiptComponent"]
    },
    {
        path: 'success',
        component: _success_success_component__WEBPACK_IMPORTED_MODULE_8__["SuccessComponent"]
    }
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [],
        imports: [
            _angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes)
        ],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.css":
/*!***********************************!*\
  !*** ./src/app/app.component.css ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("#app-container {\n    margin: auto;\n    max-width: 800px;\n}\n\n.title {\n    margin-bottom: 24px;\n    text-align: center;\n}\n\n.custom-loading {\n    position: fixed;\n    background-color: rgba(0, 0, 0, 0.5);\n    width: 100%;\n    height: 100%;\n    z-index: 9999;\n    top: 0;\n    left: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.spinner-container {\n    background-color: #ffffff;\n    border-radius: 5px;\n    padding: 10px;\n}\n\n.spinner-text {\n    margin-bottom: 8px;\n    text-align: center;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvYXBwLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxZQUFZO0lBQ1osZ0JBQWdCO0FBQ3BCOztBQUVBO0lBQ0ksbUJBQW1CO0lBQ25CLGtCQUFrQjtBQUN0Qjs7QUFFQTtJQUNJLGVBQWU7SUFDZixvQ0FBb0M7SUFDcEMsV0FBVztJQUNYLFlBQVk7SUFDWixhQUFhO0lBQ2IsTUFBTTtJQUNOLE9BQU87SUFDUCxhQUFhO0lBQ2IsbUJBQW1CO0lBQ25CLHVCQUF1QjtBQUMzQjs7QUFFQTtJQUNJLHlCQUF5QjtJQUN6QixrQkFBa0I7SUFDbEIsYUFBYTtBQUNqQjs7QUFFQTtJQUNJLGtCQUFrQjtJQUNsQixrQkFBa0I7QUFDdEIiLCJmaWxlIjoic3JjL2FwcC9hcHAuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIiNhcHAtY29udGFpbmVyIHtcbiAgICBtYXJnaW46IGF1dG87XG4gICAgbWF4LXdpZHRoOiA4MDBweDtcbn1cblxuLnRpdGxlIHtcbiAgICBtYXJnaW4tYm90dG9tOiAyNHB4O1xuICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbn1cblxuLmN1c3RvbS1sb2FkaW5nIHtcbiAgICBwb3NpdGlvbjogZml4ZWQ7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogcmdiYSgwLCAwLCAwLCAwLjUpO1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIGhlaWdodDogMTAwJTtcbiAgICB6LWluZGV4OiA5OTk5O1xuICAgIHRvcDogMDtcbiAgICBsZWZ0OiAwO1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbn1cblxuLnNwaW5uZXItY29udGFpbmVyIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmZmZmZmO1xuICAgIGJvcmRlci1yYWRpdXM6IDVweDtcbiAgICBwYWRkaW5nOiAxMHB4O1xufVxuXG4uc3Bpbm5lci10ZXh0IHtcbiAgICBtYXJnaW4tYm90dG9tOiA4cHg7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xufVxuIl19 */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _core_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./core/spinner/spinner.service */ "./src/app/core/spinner/spinner.service.ts");



let AppComponent = class AppComponent {
    constructor(spinner) {
        this.spinner = spinner;
        this.title = 'Tower Hill Insurance';
    }
    ngOnInit() {
        this.spinner.status.subscribe(uiState => {
            setTimeout(() => {
                this.showLoader = uiState.actionOngoing;
            }, 10);
        });
    }
};
AppComponent.ctorParameters = () => [
    { type: _core_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_2__["SpinnerService"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.css */ "./src/app/app.component.css")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _core_alert_alert_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./core/alert/alert.component */ "./src/app/core/alert/alert.component.ts");
/* harmony import */ var _core_http_interceptor_http_interceptor_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./core/http-interceptor/http-interceptor.service */ "./src/app/core/http-interceptor/http-interceptor.service.ts");
/* harmony import */ var _interceptors_authentication_interceptor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./interceptors/authentication.interceptor */ "./src/app/interceptors/authentication.interceptor.ts");
/* harmony import */ var _billing_form_billing_form_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./billing-form/billing-form.component */ "./src/app/billing-form/billing-form.component.ts");
/* harmony import */ var _error_error_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./error/error.component */ "./src/app/error/error.component.ts");
/* harmony import */ var _payment_form_payment_form_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./payment-form/payment-form.component */ "./src/app/payment-form/payment-form.component.ts");
/* harmony import */ var _payment_receipt_payment_receipt_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./payment-receipt/payment-receipt.component */ "./src/app/payment-receipt/payment-receipt.component.ts");
/* harmony import */ var _payment_review_payment_review_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./payment-review/payment-review.component */ "./src/app/payment-review/payment-review.component.ts");
/* harmony import */ var _success_success_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./success/success.component */ "./src/app/success/success.component.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_material_button__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @angular/material/button */ "./node_modules/@angular/material/esm2015/button.js");
/* harmony import */ var _angular_material_card__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @angular/material/card */ "./node_modules/@angular/material/esm2015/card.js");
/* harmony import */ var _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @angular/material/checkbox */ "./node_modules/@angular/material/esm2015/checkbox.js");
/* harmony import */ var _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @angular/material/datepicker */ "./node_modules/@angular/material/esm2015/datepicker.js");
/* harmony import */ var _angular_material_divider__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @angular/material/divider */ "./node_modules/@angular/material/esm2015/divider.js");
/* harmony import */ var _angular_material_form_field__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @angular/material/form-field */ "./node_modules/@angular/material/esm2015/form-field.js");
/* harmony import */ var _angular_material_list__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @angular/material/list */ "./node_modules/@angular/material/esm2015/list.js");
/* harmony import */ var _angular_material_icon__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @angular/material/icon */ "./node_modules/@angular/material/esm2015/icon.js");
/* harmony import */ var _angular_material_input__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @angular/material/input */ "./node_modules/@angular/material/esm2015/input.js");
/* harmony import */ var _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @angular/material/progress-spinner */ "./node_modules/@angular/material/esm2015/progress-spinner.js");
/* harmony import */ var _angular_material_radio__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @angular/material/radio */ "./node_modules/@angular/material/esm2015/radio.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _angular_material_stepper__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @angular/material/stepper */ "./node_modules/@angular/material/esm2015/stepper.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
































let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_3__["AppComponent"],
            _core_alert_alert_component__WEBPACK_IMPORTED_MODULE_5__["AlertComponent"],
            _billing_form_billing_form_component__WEBPACK_IMPORTED_MODULE_8__["BillingFormComponent"],
            _error_error_component__WEBPACK_IMPORTED_MODULE_9__["ErrorComponent"],
            _payment_form_payment_form_component__WEBPACK_IMPORTED_MODULE_10__["PaymentFormComponent"],
            _payment_receipt_payment_receipt_component__WEBPACK_IMPORTED_MODULE_11__["PaymentReceiptComponent"],
            _payment_review_payment_review_component__WEBPACK_IMPORTED_MODULE_12__["PaymentReviewComponent"],
            _success_success_component__WEBPACK_IMPORTED_MODULE_13__["SuccessComponent"]
        ],
        imports: [
            _app_routing_module__WEBPACK_IMPORTED_MODULE_4__["AppRoutingModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_14__["BrowserAnimationsModule"],
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_15__["HttpClientModule"],
            _angular_material_button__WEBPACK_IMPORTED_MODULE_17__["MatButtonModule"],
            _angular_material_card__WEBPACK_IMPORTED_MODULE_18__["MatCardModule"],
            _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_19__["MatCheckboxModule"],
            _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_20__["MatDatepickerModule"],
            _angular_material_divider__WEBPACK_IMPORTED_MODULE_21__["MatDividerModule"],
            _angular_material_form_field__WEBPACK_IMPORTED_MODULE_22__["MatFormFieldModule"],
            _angular_material_icon__WEBPACK_IMPORTED_MODULE_24__["MatIconModule"],
            _angular_material_input__WEBPACK_IMPORTED_MODULE_25__["MatInputModule"],
            _angular_material_list__WEBPACK_IMPORTED_MODULE_23__["MatListModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_31__["MatNativeDateModule"],
            _angular_material_radio__WEBPACK_IMPORTED_MODULE_27__["MatRadioModule"],
            _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_28__["MatSnackBarModule"],
            _angular_material_stepper__WEBPACK_IMPORTED_MODULE_29__["MatStepperModule"],
            _angular_material_table__WEBPACK_IMPORTED_MODULE_30__["MatTableModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_16__["ReactiveFormsModule"],
            _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_26__["MatProgressSpinnerModule"]
        ],
        providers: [
            { provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_15__["HTTP_INTERCEPTORS"], useClass: _core_http_interceptor_http_interceptor_service__WEBPACK_IMPORTED_MODULE_6__["HttpConfigInterceptor"], multi: true },
            { provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_15__["HTTP_INTERCEPTORS"], useClass: _interceptors_authentication_interceptor__WEBPACK_IMPORTED_MODULE_7__["AuthenticationInterceptor"], multi: true }
        ],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_3__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/billing-form/billing-form.component.css":
/*!*********************************************************!*\
  !*** ./src/app/billing-form/billing-form.component.css ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".title {\n    display: flex;\n    align-items: center;\n}\n\n.title-text {\n    margin-left: 6px;\n}\n\n.selection-table {\n    margin-bottom: 24px;\n    margin-top: 4px;\n    width: 100%;\n}\n\n.selection-table-header-row {\n    background: rgba(0, 0, 0, 0.08);\n}\n\n.selection-table-row:hover {\n    background: rgba(128, 128, 128, 0.08);\n    cursor: pointer;\n}\n\n.selection-table-row-disabled:hover {\n    background: inherit;\n    cursor: default;\n}\n\n.selection-table-row-disabled .mat-cell {\n    color: rgba(128, 128, 128, 0.5);\n}\n\n#button-row {\n    display: flex;\n}\n\n#button-spacer {\n    flex-grow: 1;\n}\n\n.submit-button {\n    margin: 8px;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvYmlsbGluZy1mb3JtL2JpbGxpbmctZm9ybS5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksYUFBYTtJQUNiLG1CQUFtQjtBQUN2Qjs7QUFFQTtJQUNJLGdCQUFnQjtBQUNwQjs7QUFFQTtJQUNJLG1CQUFtQjtJQUNuQixlQUFlO0lBQ2YsV0FBVztBQUNmOztBQUVBO0lBQ0ksK0JBQStCO0FBQ25DOztBQUVBO0lBQ0kscUNBQXFDO0lBQ3JDLGVBQWU7QUFDbkI7O0FBRUE7SUFDSSxtQkFBbUI7SUFDbkIsZUFBZTtBQUNuQjs7QUFFQTtJQUNJLCtCQUErQjtBQUNuQzs7QUFFQTtJQUNJLGFBQWE7QUFDakI7O0FBRUE7SUFDSSxZQUFZO0FBQ2hCOztBQUVBO0lBQ0ksV0FBVztBQUNmIiwiZmlsZSI6InNyYy9hcHAvYmlsbGluZy1mb3JtL2JpbGxpbmctZm9ybS5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnRpdGxlIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG59XG5cbi50aXRsZS10ZXh0IHtcbiAgICBtYXJnaW4tbGVmdDogNnB4O1xufVxuXG4uc2VsZWN0aW9uLXRhYmxlIHtcbiAgICBtYXJnaW4tYm90dG9tOiAyNHB4O1xuICAgIG1hcmdpbi10b3A6IDRweDtcbiAgICB3aWR0aDogMTAwJTtcbn1cblxuLnNlbGVjdGlvbi10YWJsZS1oZWFkZXItcm93IHtcbiAgICBiYWNrZ3JvdW5kOiByZ2JhKDAsIDAsIDAsIDAuMDgpO1xufVxuXG4uc2VsZWN0aW9uLXRhYmxlLXJvdzpob3ZlciB7XG4gICAgYmFja2dyb3VuZDogcmdiYSgxMjgsIDEyOCwgMTI4LCAwLjA4KTtcbiAgICBjdXJzb3I6IHBvaW50ZXI7XG59XG5cbi5zZWxlY3Rpb24tdGFibGUtcm93LWRpc2FibGVkOmhvdmVyIHtcbiAgICBiYWNrZ3JvdW5kOiBpbmhlcml0O1xuICAgIGN1cnNvcjogZGVmYXVsdDtcbn1cblxuLnNlbGVjdGlvbi10YWJsZS1yb3ctZGlzYWJsZWQgLm1hdC1jZWxsIHtcbiAgICBjb2xvcjogcmdiYSgxMjgsIDEyOCwgMTI4LCAwLjUpO1xufVxuXG4jYnV0dG9uLXJvdyB7XG4gICAgZGlzcGxheTogZmxleDtcbn1cblxuI2J1dHRvbi1zcGFjZXIge1xuICAgIGZsZXgtZ3JvdzogMTtcbn1cblxuLnN1Ym1pdC1idXR0b24ge1xuICAgIG1hcmdpbjogOHB4O1xufVxuIl19 */");

/***/ }),

/***/ "./src/app/billing-form/billing-form.component.ts":
/*!********************************************************!*\
  !*** ./src/app/billing-form/billing-form.component.ts ***!
  \********************************************************/
/*! exports provided: BillingFormComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BillingFormComponent", function() { return BillingFormComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/collections */ "./node_modules/@angular/cdk/esm2015/collections.js");
/* harmony import */ var _core_alert_alert_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../core/alert/alert.service */ "./src/app/core/alert/alert.service.ts");
/* harmony import */ var _model_billing_options__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../model/billing-options */ "./src/app/model/billing-options.ts");
/* harmony import */ var _services_billing_options_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../services/billing-options.service */ "./src/app/services/billing-options.service.ts");
/* harmony import */ var _services_submission_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../services/submission.service */ "./src/app/services/submission.service.ts");








let BillingFormComponent = class BillingFormComponent {
    constructor(alertService, billingOptionsService, router, submissionService) {
        this.alertService = alertService;
        this.billingOptionsService = billingOptionsService;
        this.router = router;
        this.submissionService = submissionService;
        this.INSURED = 'Insured';
        this.LIENHOLDER = 'Lienholder';
        this.MAILING_ADDRESS = 'MailingAddress';
        this.PAY_IN_FULL = 'PAY IN FULL';
        this.billeeColumns = ['select', 'name', 'type', 'address'];
        this.billeeSelection = new _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_3__["SelectionModel"](false, []);
        this.canSubmitWithoutPayment = false;
        this.canSubmitWithPayment = false;
        this.paymentPlanColumns = ['select', 'name', 'description', 'downPayment', 'installment', 'numberOfInstallments', 'installFee', 'netDue'];
        this.paymentPlanSelection = new _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_3__["SelectionModel"](false, []);
    }
    ngOnInit() {
        this.billingOptions = new _model_billing_options__WEBPACK_IMPORTED_MODULE_5__["BillingOptions"]();
        this.getBillingOptions();
        const billee = this.billingOptionsService.getSelectedBillee();
        const paymentPlan = this.billingOptionsService.getSelectedPaymentPlan();
        if (billee) {
            this.billeeSelection.select(billee);
        }
        if (paymentPlan) {
            this.paymentPlanSelection.select(paymentPlan);
        }
        this.updateCanSubmit();
    }
    getBillingOptions() {
        this.billingOptionsService.getBillingOptions()
            .subscribe(billingOptions => {
            this.billingOptions = billingOptions;
            this.billingOptionsService.setBillingOptions(billingOptions);
            this.billingOptionsService.setPolicyNumber(billingOptions.policyNumber);
        });
    }
    isDisabled(paymentPlan) {
        if (paymentPlan.name === this.PAY_IN_FULL) {
            return false;
        }
        return this.billeeSelection.hasValue() && this.billeeSelection.selected[0].type === this.LIENHOLDER;
    }
    onBilleeChange(billee) {
        this.billeeSelection.select(billee);
        this.updateCanSubmit();
        if (billee.type === this.LIENHOLDER) {
            this.selectPayInFull();
        }
        this.billingOptionsService.setSelectedBillee(billee);
        this.paymentPlanTable.renderRows();
    }
    onPaymentPlanChange(paymentPlan) {
        if (this.isDisabled(paymentPlan)) {
            return;
        }
        this.paymentPlanSelection.select(paymentPlan);
        this.billingOptionsService.setSelectedPaymentPlan(paymentPlan);
        this.updateCanSubmit();
    }
    selectPayInFull() {
        this.onPaymentPlanChange(this.billingOptions.paymentPlans.find(p => p.name === this.PAY_IN_FULL));
    }
    submitWithoutPayment() {
        this.submissionService.submitWithoutPayment(this.billeeSelection.selected[0].id, this.PAY_IN_FULL)
            .subscribe(res => {
            if (res.success) {
                // noinspection JSIgnoredPromiseFromCall
                this.router.navigateByUrl('/success');
            }
            else {
                this.alertService.error(res.errors.join('\n'));
            }
        });
    }
    updateCanSubmit() {
        const canSubmit = this.billeeSelection.hasValue() && this.paymentPlanSelection.hasValue();
        const selectedBilleeType = this.billeeSelection.selected[0].type;
        this.canSubmitWithPayment = canSubmit &&
            (selectedBilleeType === this.INSURED || selectedBilleeType === this.MAILING_ADDRESS);
        this.canSubmitWithoutPayment = canSubmit && selectedBilleeType === this.LIENHOLDER;
    }
};
BillingFormComponent.ctorParameters = () => [
    { type: _core_alert_alert_service__WEBPACK_IMPORTED_MODULE_4__["AlertService"] },
    { type: _services_billing_options_service__WEBPACK_IMPORTED_MODULE_6__["BillingOptionsService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _services_submission_service__WEBPACK_IMPORTED_MODULE_7__["SubmissionService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('paymentPlanTable', { static: false })
], BillingFormComponent.prototype, "paymentPlanTable", void 0);
BillingFormComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-billing-form',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./billing-form.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/billing-form/billing-form.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./billing-form.component.css */ "./src/app/billing-form/billing-form.component.css")).default]
    })
], BillingFormComponent);



/***/ }),

/***/ "./src/app/core/alert/alert.component.css":
/*!************************************************!*\
  !*** ./src/app/core/alert/alert.component.css ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".error {\n    background-color: #f44336;\n}\n\n.success {\n    background-color: #4caf50;\n}\n\n.info {\n    background-color: #2196f3;\n}\n\n.warning {\n    background-color: #ff9800;\n}\n\n/* The alert message box */\n\n.alert {\n    border-radius: 4px;\n    color: white;\n    display: flex;\n    height: 24px;\n    margin-bottom: 8px;\n    padding: 12px;\n}\n\n.message {\n    flex-grow: 1;\n}\n\n/* The close button */\n\n.close-button {\n    cursor: pointer;\n    transition: 0.3s;\n}\n\n/* When moving the mouse over the close button */\n\n.close-button:hover {\n    color: black;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29yZS9hbGVydC9hbGVydC5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0kseUJBQXlCO0FBQzdCOztBQUVBO0lBQ0kseUJBQXlCO0FBQzdCOztBQUVBO0lBQ0kseUJBQXlCO0FBQzdCOztBQUVBO0lBQ0kseUJBQXlCO0FBQzdCOztBQUVBLDBCQUEwQjs7QUFDMUI7SUFDSSxrQkFBa0I7SUFDbEIsWUFBWTtJQUNaLGFBQWE7SUFDYixZQUFZO0lBQ1osa0JBQWtCO0lBQ2xCLGFBQWE7QUFDakI7O0FBRUE7SUFDSSxZQUFZO0FBQ2hCOztBQUVBLHFCQUFxQjs7QUFDckI7SUFDSSxlQUFlO0lBQ2YsZ0JBQWdCO0FBQ3BCOztBQUVBLGdEQUFnRDs7QUFDaEQ7SUFDSSxZQUFZO0FBQ2hCIiwiZmlsZSI6InNyYy9hcHAvY29yZS9hbGVydC9hbGVydC5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmVycm9yIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZjQ0MzM2O1xufVxuXG4uc3VjY2VzcyB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogIzRjYWY1MDtcbn1cblxuLmluZm8ge1xuICAgIGJhY2tncm91bmQtY29sb3I6ICMyMTk2ZjM7XG59XG5cbi53YXJuaW5nIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmY5ODAwO1xufVxuXG4vKiBUaGUgYWxlcnQgbWVzc2FnZSBib3ggKi9cbi5hbGVydCB7XG4gICAgYm9yZGVyLXJhZGl1czogNHB4O1xuICAgIGNvbG9yOiB3aGl0ZTtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGhlaWdodDogMjRweDtcbiAgICBtYXJnaW4tYm90dG9tOiA4cHg7XG4gICAgcGFkZGluZzogMTJweDtcbn1cblxuLm1lc3NhZ2Uge1xuICAgIGZsZXgtZ3JvdzogMTtcbn1cblxuLyogVGhlIGNsb3NlIGJ1dHRvbiAqL1xuLmNsb3NlLWJ1dHRvbiB7XG4gICAgY3Vyc29yOiBwb2ludGVyO1xuICAgIHRyYW5zaXRpb246IDAuM3M7XG59XG5cbi8qIFdoZW4gbW92aW5nIHRoZSBtb3VzZSBvdmVyIHRoZSBjbG9zZSBidXR0b24gKi9cbi5jbG9zZS1idXR0b246aG92ZXIge1xuICAgIGNvbG9yOiBibGFjaztcbn1cbiJdfQ== */");

/***/ }),

/***/ "./src/app/core/alert/alert.component.ts":
/*!***********************************************!*\
  !*** ./src/app/core/alert/alert.component.ts ***!
  \***********************************************/
/*! exports provided: AlertComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AlertComponent", function() { return AlertComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _alert_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./alert.service */ "./src/app/core/alert/alert.service.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _model_alert__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../model/alert */ "./src/app/model/alert.ts");




let AlertComponent = class AlertComponent {
    constructor(alertService) {
        this.alertService = alertService;
        this.alerts = [];
    }
    ngOnInit() {
        this.alertService.getAlert().subscribe((alert) => {
            if (!alert) {
                // clear alerts when an empty alert is received
                this.alerts = [];
                return;
            }
            // add alert to array
            this.alerts.push(alert);
        });
    }
    removeAlert(alert) {
        this.alerts = this.alerts.filter(x => x !== alert);
    }
    cssClass(alert) {
        if (!alert) {
            return;
        }
        // return css class based on alert type
        switch (alert.type) {
            case _model_alert__WEBPACK_IMPORTED_MODULE_3__["AlertType"].Success:
                return 'success';
            case _model_alert__WEBPACK_IMPORTED_MODULE_3__["AlertType"].Error:
                return 'error';
            case _model_alert__WEBPACK_IMPORTED_MODULE_3__["AlertType"].Info:
                return 'info';
            case _model_alert__WEBPACK_IMPORTED_MODULE_3__["AlertType"].Warning:
                return 'warning';
        }
    }
};
AlertComponent.ctorParameters = () => [
    { type: _alert_service__WEBPACK_IMPORTED_MODULE_1__["AlertService"] }
];
AlertComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"])({
        selector: 'app-alert',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./alert.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/alert/alert.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./alert.component.css */ "./src/app/core/alert/alert.component.css")).default]
    })
], AlertComponent);



/***/ }),

/***/ "./src/app/core/alert/alert.service.ts":
/*!*********************************************!*\
  !*** ./src/app/core/alert/alert.service.ts ***!
  \*********************************************/
/*! exports provided: AlertService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AlertService", function() { return AlertService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _model_alert__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../model/alert */ "./src/app/model/alert.ts");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/*
*
* This service is here to display alerts to the user based upon UI interactions with the user.
*
*/





let AlertService = class AlertService {
    constructor(router) {
        this.router = router;
        this.subject = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
        this.keepAfterRouteChange = false;
        // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
        router.events.subscribe(event => {
            if (event instanceof _angular_router__WEBPACK_IMPORTED_MODULE_3__["NavigationStart"]) {
                if (this.keepAfterRouteChange) {
                    // only keep for a single route change
                    this.keepAfterRouteChange = false;
                }
                else {
                    // clear alert messages
                    this.clear();
                }
            }
        });
    }
    getAlert() {
        return this.subject.asObservable();
    }
    error(message, keepAfterRouteChange = false) {
        this.alert(_model_alert__WEBPACK_IMPORTED_MODULE_1__["AlertType"].Error, message, keepAfterRouteChange);
    }
    info(message, keepAfterRouteChange = false) {
        this.alert(_model_alert__WEBPACK_IMPORTED_MODULE_1__["AlertType"].Info, message, keepAfterRouteChange);
    }
    success(message, keepAfterRouteChange = false) {
        this.alert(_model_alert__WEBPACK_IMPORTED_MODULE_1__["AlertType"].Success, message, keepAfterRouteChange);
    }
    warning(message, keepAfterRouteChange = false) {
        this.alert(_model_alert__WEBPACK_IMPORTED_MODULE_1__["AlertType"].Warning, message, keepAfterRouteChange);
    }
    alert(type, message, keepAfterRouteChange = false) {
        if (message && message.length > 0) {
            this.keepAfterRouteChange = keepAfterRouteChange;
            this.subject.next({ type, message });
        }
    }
    clear() {
        // clear alerts
        this.subject.next();
    }
};
AlertService.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] }
];
AlertService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["Injectable"])({
        providedIn: 'root'
    })
], AlertService);



/***/ }),

/***/ "./src/app/core/http-interceptor/http-interceptor.service.ts":
/*!*******************************************************************!*\
  !*** ./src/app/core/http-interceptor/http-interceptor.service.ts ***!
  \*******************************************************************/
/*! exports provided: HttpConfigInterceptor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpConfigInterceptor", function() { return HttpConfigInterceptor; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _alert_alert_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../alert/alert.service */ "./src/app/core/alert/alert.service.ts");
/* harmony import */ var _model_constants_messages__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../model/constants/messages */ "./src/app/model/constants/messages.ts");
/* harmony import */ var _spinner_spinner_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../spinner/spinner.service */ "./src/app/core/spinner/spinner.service.ts");








let HttpConfigInterceptor = class HttpConfigInterceptor {
    constructor(alertService, router, spinner) {
        this.alertService = alertService;
        this.router = router;
        this.spinner = spinner;
        this.count = 0;
        this.defaultSpinnerInterval = 0.4;
        this.defaultTimeout = 100;
    }
    intercept(request, next) {
        const timeoutValue = Number(request.headers.get('timeout')) || this.defaultTimeout;
        const spinnerInterval = Number(request.headers.get('spinnerInterval')) || this.defaultSpinnerInterval;
        setTimeout(() => {
            this.count++;
            if (this.count >= 1) {
                this.spinner.startBackendAction();
            }
        }, spinnerInterval * 1000);
        if (!request.headers.has('Content-Type')) {
            request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        }
        return next.handle(request).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["timeout"])(timeoutValue * 1000), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])((error) => {
            const data = {
                reason: error && error.error && error.error.reason ?
                    error.error.reason : error.message ? error.message : 'Error in your request',
                status: error.status
            };
            console.error('ERROR:', data);
            if (error.status === 403) {
                // Redirect since this is not a recoverable error.
                this.router.navigate(['/error'], { queryParams: { message: _model_constants_messages__WEBPACK_IMPORTED_MODULE_6__["Messages"].NOT_AUTHENTICATED_ERROR } });
            }
            else {
                // Show the error and stay on the page so the user can try again.
                this.alertService.error(error.message);
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(error);
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["finalize"])(() => {
            this.count--;
            if (this.count === 0) {
                this.spinner.endBackendAction();
            }
        }));
    }
};
HttpConfigInterceptor.ctorParameters = () => [
    { type: _alert_alert_service__WEBPACK_IMPORTED_MODULE_5__["AlertService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _spinner_spinner_service__WEBPACK_IMPORTED_MODULE_7__["SpinnerService"] }
];
HttpConfigInterceptor = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], HttpConfigInterceptor);



/***/ }),

/***/ "./src/app/core/spinner/spinner.service.ts":
/*!*************************************************!*\
  !*** ./src/app/core/spinner/spinner.service.ts ***!
  \*************************************************/
/*! exports provided: SpinnerService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SpinnerService", function() { return SpinnerService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _model_constants_messages__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../model/constants/messages */ "./src/app/model/constants/messages.ts");
/* harmony import */ var _model_ui_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../model/ui-state */ "./src/app/model/ui-state.ts");





let SpinnerService = class SpinnerService {
    constructor() {
        this.status = new rxjs__WEBPACK_IMPORTED_MODULE_1__["BehaviorSubject"](_model_ui_state__WEBPACK_IMPORTED_MODULE_4__["initialUiState"]);
    }
    startBackendAction(message = _model_constants_messages__WEBPACK_IMPORTED_MODULE_3__["Messages"].STANDARD_SPINNER_MESSAGE) {
        this.status.next({
            actionOngoing: true,
            message
        });
    }
    endBackendAction() {
        this.status.next({
            actionOngoing: false,
            message: ''
        });
    }
};
SpinnerService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: 'root'
    })
], SpinnerService);



/***/ }),

/***/ "./src/app/error/error.component.css":
/*!*******************************************!*\
  !*** ./src/app/error/error.component.css ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("#error-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n#error-message {\n    margin-left: 6px;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvZXJyb3IvZXJyb3IuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLGFBQWE7SUFDYixtQkFBbUI7SUFDbkIsdUJBQXVCO0FBQzNCOztBQUVBO0lBQ0ksZ0JBQWdCO0FBQ3BCIiwiZmlsZSI6InNyYy9hcHAvZXJyb3IvZXJyb3IuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIiNlcnJvci1jb250YWluZXIge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbn1cblxuI2Vycm9yLW1lc3NhZ2Uge1xuICAgIG1hcmdpbi1sZWZ0OiA2cHg7XG59XG4iXX0= */");

/***/ }),

/***/ "./src/app/error/error.component.ts":
/*!******************************************!*\
  !*** ./src/app/error/error.component.ts ***!
  \******************************************/
/*! exports provided: ErrorComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorComponent", function() { return ErrorComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");



let ErrorComponent = class ErrorComponent {
    constructor(route) {
        this.route = route;
    }
    ngOnInit() {
        if (this.route.snapshot.queryParamMap.has('message')) {
            this.errorMessage = this.route.snapshot.queryParamMap.get('message');
        }
        else {
            this.errorMessage = 'An error has occurred. Please try again later.';
        }
    }
};
ErrorComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] }
];
ErrorComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-error',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./error.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/error/error.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./error.component.css */ "./src/app/error/error.component.css")).default]
    })
], ErrorComponent);



/***/ }),

/***/ "./src/app/interceptors/authentication.interceptor.ts":
/*!************************************************************!*\
  !*** ./src/app/interceptors/authentication.interceptor.ts ***!
  \************************************************************/
/*! exports provided: AuthenticationInterceptor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthenticationInterceptor", function() { return AuthenticationInterceptor; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_billing_options_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../services/billing-options.service */ "./src/app/services/billing-options.service.ts");



let AuthenticationInterceptor = class AuthenticationInterceptor {
    constructor(billingOptionsService) {
        this.billingOptionsService = billingOptionsService;
    }
    intercept(request, next) {
        request = request.clone({
            headers: request.headers
                .set('X-Requested-With', 'XMLHttpRequest')
                .set('Authorization', `Bearer ${this.billingOptionsService.getToken()}`)
        });
        return next.handle(request);
    }
};
AuthenticationInterceptor.ctorParameters = () => [
    { type: _services_billing_options_service__WEBPACK_IMPORTED_MODULE_2__["BillingOptionsService"] }
];
AuthenticationInterceptor = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], AuthenticationInterceptor);



/***/ }),

/***/ "./src/app/model/alert.ts":
/*!********************************!*\
  !*** ./src/app/model/alert.ts ***!
  \********************************/
/*! exports provided: Alert, AlertType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Alert", function() { return Alert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AlertType", function() { return AlertType; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class Alert {
}
var AlertType;
(function (AlertType) {
    AlertType[AlertType["Success"] = 0] = "Success";
    AlertType[AlertType["Error"] = 1] = "Error";
    AlertType[AlertType["Info"] = 2] = "Info";
    AlertType[AlertType["Warning"] = 3] = "Warning";
})(AlertType || (AlertType = {}));


/***/ }),

/***/ "./src/app/model/billing-options.ts":
/*!******************************************!*\
  !*** ./src/app/model/billing-options.ts ***!
  \******************************************/
/*! exports provided: BillingOptions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BillingOptions", function() { return BillingOptions; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class BillingOptions {
}


/***/ }),

/***/ "./src/app/model/constants/messages.ts":
/*!*********************************************!*\
  !*** ./src/app/model/constants/messages.ts ***!
  \*********************************************/
/*! exports provided: Messages */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Messages", function() { return Messages; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class Messages {
}
Messages.DATE_ERROR = 'Please enter a valid date (MM/DD/YYYY).';
Messages.FUTURE_DATE_ERROR = 'Please enter a date (MM/DD/YYYY) today\'s date or later.';
Messages.YEAR_ERROR = 'Please enter a valid year (YYYY).';
Messages.SELECT_ERROR = 'Please select a value.';
Messages.EMAIL_ERROR = 'Please enter a valid email address.';
Messages.PHONE_ERROR = 'Please enter a valid phone number.';
Messages.FORM_ERROR = 'There are invalid or incomplete form entries. Please make corrections to continue.';
Messages.SERVER_ERROR = 'The application is experiencing technical difficulties. Please try again later.';
Messages.REQUIRED_ERROR = 'This field is required.';
Messages.NOT_AUTHENTICATED_ERROR = 'You are not authenticated.';
Messages.STANDARD_SPINNER_MESSAGE = 'Processing...';


/***/ }),

/***/ "./src/app/model/payment-details.ts":
/*!******************************************!*\
  !*** ./src/app/model/payment-details.ts ***!
  \******************************************/
/*! exports provided: PaymentDetails */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PaymentDetails", function() { return PaymentDetails; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class PaymentDetails {
}


/***/ }),

/***/ "./src/app/model/ui-state.ts":
/*!***********************************!*\
  !*** ./src/app/model/ui-state.ts ***!
  \***********************************/
/*! exports provided: UiState, initialUiState */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UiState", function() { return UiState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initialUiState", function() { return initialUiState; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class UiState {
    constructor(actionOngoing, message) {
        this.actionOngoing = actionOngoing;
        this.message = message;
    }
}
const initialUiState = {
    actionOngoing: false,
    message: 'Ready'
};


/***/ }),

/***/ "./src/app/payment-form/payment-form.component.css":
/*!*********************************************************!*\
  !*** ./src/app/payment-form/payment-form.component.css ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("#back-button {\n    margin-top: 24px;\n    padding-left: 8px;\n}\n\n.title {\n    display: flex;\n    align-items: center;\n}\n\n.title-text {\n    margin-left: 6px;\n}\n\n.payment-form-container {\n    display: flex;\n    align-items: center;\n}\n\n.payment-amount-container, .payment-date-container {\n    flex-grow: 1;\n}\n\n.payment-amount-radio-group {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 16px;\n    margin-top: 4px;\n}\n\n.payment-amount-radio-button {\n    margin: 4px;\n}\n\n.payment-types {\n    display: flex;\n    margin-top: 24px;\n}\n\n.payment-type {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.payment-button {\n    margin-bottom: 8px;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcGF5bWVudC1mb3JtL3BheW1lbnQtZm9ybS5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksZ0JBQWdCO0lBQ2hCLGlCQUFpQjtBQUNyQjs7QUFFQTtJQUNJLGFBQWE7SUFDYixtQkFBbUI7QUFDdkI7O0FBRUE7SUFDSSxnQkFBZ0I7QUFDcEI7O0FBRUE7SUFDSSxhQUFhO0lBQ2IsbUJBQW1CO0FBQ3ZCOztBQUVBO0lBQ0ksWUFBWTtBQUNoQjs7QUFFQTtJQUNJLGFBQWE7SUFDYixzQkFBc0I7SUFDdEIsbUJBQW1CO0lBQ25CLGVBQWU7QUFDbkI7O0FBRUE7SUFDSSxXQUFXO0FBQ2Y7O0FBRUE7SUFDSSxhQUFhO0lBQ2IsZ0JBQWdCO0FBQ3BCOztBQUVBO0lBQ0ksWUFBWTtJQUNaLGFBQWE7SUFDYixzQkFBc0I7SUFDdEIsbUJBQW1CO0FBQ3ZCOztBQUVBO0lBQ0ksa0JBQWtCO0FBQ3RCIiwiZmlsZSI6InNyYy9hcHAvcGF5bWVudC1mb3JtL3BheW1lbnQtZm9ybS5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiI2JhY2stYnV0dG9uIHtcbiAgICBtYXJnaW4tdG9wOiAyNHB4O1xuICAgIHBhZGRpbmctbGVmdDogOHB4O1xufVxuXG4udGl0bGUge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbn1cblxuLnRpdGxlLXRleHQge1xuICAgIG1hcmdpbi1sZWZ0OiA2cHg7XG59XG5cbi5wYXltZW50LWZvcm0tY29udGFpbmVyIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG59XG5cbi5wYXltZW50LWFtb3VudC1jb250YWluZXIsIC5wYXltZW50LWRhdGUtY29udGFpbmVyIHtcbiAgICBmbGV4LWdyb3c6IDE7XG59XG5cbi5wYXltZW50LWFtb3VudC1yYWRpby1ncm91cCB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgIG1hcmdpbi1ib3R0b206IDE2cHg7XG4gICAgbWFyZ2luLXRvcDogNHB4O1xufVxuXG4ucGF5bWVudC1hbW91bnQtcmFkaW8tYnV0dG9uIHtcbiAgICBtYXJnaW46IDRweDtcbn1cblxuLnBheW1lbnQtdHlwZXMge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgbWFyZ2luLXRvcDogMjRweDtcbn1cblxuLnBheW1lbnQtdHlwZSB7XG4gICAgZmxleC1ncm93OiAxO1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xufVxuXG4ucGF5bWVudC1idXR0b24ge1xuICAgIG1hcmdpbi1ib3R0b206IDhweDtcbn1cbiJdfQ== */");

/***/ }),

/***/ "./src/app/payment-form/payment-form.component.ts":
/*!********************************************************!*\
  !*** ./src/app/payment-form/payment-form.component.ts ***!
  \********************************************************/
/*! exports provided: PaymentFormComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PaymentFormComponent", function() { return PaymentFormComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _services_billing_options_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../services/billing-options.service */ "./src/app/services/billing-options.service.ts");
/* harmony import */ var _services_one_inc_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../services/one-inc.service */ "./src/app/services/one-inc.service.ts");





let PaymentFormComponent = class PaymentFormComponent {
    constructor(billingOptionsService, oneIncService, fb) {
        this.billingOptionsService = billingOptionsService;
        this.oneIncService = oneIncService;
        this.fb = fb;
        this.paymentForm = this.fb.group({
            paymentAmount: [''],
            paymentDate: [new Date()]
        });
        this.minimumDate = new Date();
        this.maximumDate = new Date(this.minimumDate.getFullYear(), this.minimumDate.getMonth(), this.minimumDate.getDate() + 14);
    }
    ngOnInit() {
        this.getPaymentPlan();
    }
    isButtonDisabled() {
        return this.paymentForm.get('paymentAmount').value === '' ||
            this.paymentForm.get('paymentDate').value === null;
    }
    getPaymentPlan() {
        this.paymentPlan = this.billingOptionsService.getSelectedPaymentPlan();
    }
    selectPaymentCategory(paymentCategory) {
        const amount = this.paymentForm.get('paymentAmount').value === 'minimum' ?
            this.paymentPlan.downPayment :
            this.paymentPlan.netDue;
        const date = this.paymentForm.get('paymentDate').value;
        this.oneIncService.startOneIncProcess(paymentCategory, amount, date);
    }
};
PaymentFormComponent.ctorParameters = () => [
    { type: _services_billing_options_service__WEBPACK_IMPORTED_MODULE_3__["BillingOptionsService"] },
    { type: _services_one_inc_service__WEBPACK_IMPORTED_MODULE_4__["OneIncService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"] }
];
PaymentFormComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-payment-form',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./payment-form.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/payment-form/payment-form.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./payment-form.component.css */ "./src/app/payment-form/payment-form.component.css")).default]
    })
], PaymentFormComponent);



/***/ }),

/***/ "./src/app/payment-receipt/payment-receipt.component.css":
/*!***************************************************************!*\
  !*** ./src/app/payment-receipt/payment-receipt.component.css ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".title {\n    display: flex;\n    align-items: center;\n    margin-bottom: 12px;\n}\n\n.title-text {\n    margin-left: 6px;\n}\n\n.receipt-label {\n    font-weight: 500;\n    width: 210px;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcGF5bWVudC1yZWNlaXB0L3BheW1lbnQtcmVjZWlwdC5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksYUFBYTtJQUNiLG1CQUFtQjtJQUNuQixtQkFBbUI7QUFDdkI7O0FBRUE7SUFDSSxnQkFBZ0I7QUFDcEI7O0FBRUE7SUFDSSxnQkFBZ0I7SUFDaEIsWUFBWTtBQUNoQiIsImZpbGUiOiJzcmMvYXBwL3BheW1lbnQtcmVjZWlwdC9wYXltZW50LXJlY2VpcHQuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi50aXRsZSB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgIG1hcmdpbi1ib3R0b206IDEycHg7XG59XG5cbi50aXRsZS10ZXh0IHtcbiAgICBtYXJnaW4tbGVmdDogNnB4O1xufVxuXG4ucmVjZWlwdC1sYWJlbCB7XG4gICAgZm9udC13ZWlnaHQ6IDUwMDtcbiAgICB3aWR0aDogMjEwcHg7XG59XG4iXX0= */");

/***/ }),

/***/ "./src/app/payment-receipt/payment-receipt.component.ts":
/*!**************************************************************!*\
  !*** ./src/app/payment-receipt/payment-receipt.component.ts ***!
  \**************************************************************/
/*! exports provided: PaymentReceiptComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PaymentReceiptComponent", function() { return PaymentReceiptComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_billing_options_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../services/billing-options.service */ "./src/app/services/billing-options.service.ts");



let PaymentReceiptComponent = class PaymentReceiptComponent {
    constructor(billingOptionsService) {
        this.billingOptionsService = billingOptionsService;
    }
    ngOnInit() {
        this.paymentDetails = this.billingOptionsService.getPaymentDetails();
    }
};
PaymentReceiptComponent.ctorParameters = () => [
    { type: _services_billing_options_service__WEBPACK_IMPORTED_MODULE_2__["BillingOptionsService"] }
];
PaymentReceiptComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-payment-receipt',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./payment-receipt.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/payment-receipt/payment-receipt.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./payment-receipt.component.css */ "./src/app/payment-receipt/payment-receipt.component.css")).default]
    })
], PaymentReceiptComponent);



/***/ }),

/***/ "./src/app/payment-review/payment-review.component.css":
/*!*************************************************************!*\
  !*** ./src/app/payment-review/payment-review.component.css ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".title {\n    display: flex;\n    align-items: center;\n    margin-bottom: 12px;\n}\n\n.title-text {\n    margin-left: 6px;\n}\n\n.review-row {\n    display: flex;\n}\n\n.review-label {\n    width: 210px;\n    margin-right: 16px;\n    padding: 6px 18px;\n    font-weight: 500;\n}\n\n.review-value {\n    width: 210px;\n    background: rgba(128, 128, 128, 0.16);\n    padding: 6px 18px;\n    border: 1px solid rgba(128, 128, 128, 0.5);\n    border-radius: 4px;\n}\n\n.email-value {\n    width: 246px;\n}\n\n#save-checkbox {\n    margin-top: 8px;\n}\n\n#save-payment-details {\n    margin: 4px 8px 12px 8px;\n}\n\n#payment-notes {\n    margin-top: 16px;\n}\n\n#button-row {\n    display: flex;\n}\n\n#button-spacer {\n    flex-grow: 1;\n}\n\n.back-button {\n    margin: 8px;\n    padding-left: 8px;\n}\n\n.submit-button {\n    margin: 8px;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcGF5bWVudC1yZXZpZXcvcGF5bWVudC1yZXZpZXcuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLGFBQWE7SUFDYixtQkFBbUI7SUFDbkIsbUJBQW1CO0FBQ3ZCOztBQUVBO0lBQ0ksZ0JBQWdCO0FBQ3BCOztBQUVBO0lBQ0ksYUFBYTtBQUNqQjs7QUFFQTtJQUNJLFlBQVk7SUFDWixrQkFBa0I7SUFDbEIsaUJBQWlCO0lBQ2pCLGdCQUFnQjtBQUNwQjs7QUFFQTtJQUNJLFlBQVk7SUFDWixxQ0FBcUM7SUFDckMsaUJBQWlCO0lBQ2pCLDBDQUEwQztJQUMxQyxrQkFBa0I7QUFDdEI7O0FBRUE7SUFDSSxZQUFZO0FBQ2hCOztBQUVBO0lBQ0ksZUFBZTtBQUNuQjs7QUFFQTtJQUNJLHdCQUF3QjtBQUM1Qjs7QUFFQTtJQUNJLGdCQUFnQjtBQUNwQjs7QUFFQTtJQUNJLGFBQWE7QUFDakI7O0FBRUE7SUFDSSxZQUFZO0FBQ2hCOztBQUVBO0lBQ0ksV0FBVztJQUNYLGlCQUFpQjtBQUNyQjs7QUFFQTtJQUNJLFdBQVc7QUFDZiIsImZpbGUiOiJzcmMvYXBwL3BheW1lbnQtcmV2aWV3L3BheW1lbnQtcmV2aWV3LmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIudGl0bGUge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBtYXJnaW4tYm90dG9tOiAxMnB4O1xufVxuXG4udGl0bGUtdGV4dCB7XG4gICAgbWFyZ2luLWxlZnQ6IDZweDtcbn1cblxuLnJldmlldy1yb3cge1xuICAgIGRpc3BsYXk6IGZsZXg7XG59XG5cbi5yZXZpZXctbGFiZWwge1xuICAgIHdpZHRoOiAyMTBweDtcbiAgICBtYXJnaW4tcmlnaHQ6IDE2cHg7XG4gICAgcGFkZGluZzogNnB4IDE4cHg7XG4gICAgZm9udC13ZWlnaHQ6IDUwMDtcbn1cblxuLnJldmlldy12YWx1ZSB7XG4gICAgd2lkdGg6IDIxMHB4O1xuICAgIGJhY2tncm91bmQ6IHJnYmEoMTI4LCAxMjgsIDEyOCwgMC4xNik7XG4gICAgcGFkZGluZzogNnB4IDE4cHg7XG4gICAgYm9yZGVyOiAxcHggc29saWQgcmdiYSgxMjgsIDEyOCwgMTI4LCAwLjUpO1xuICAgIGJvcmRlci1yYWRpdXM6IDRweDtcbn1cblxuLmVtYWlsLXZhbHVlIHtcbiAgICB3aWR0aDogMjQ2cHg7XG59XG5cbiNzYXZlLWNoZWNrYm94IHtcbiAgICBtYXJnaW4tdG9wOiA4cHg7XG59XG5cbiNzYXZlLXBheW1lbnQtZGV0YWlscyB7XG4gICAgbWFyZ2luOiA0cHggOHB4IDEycHggOHB4O1xufVxuXG4jcGF5bWVudC1ub3RlcyB7XG4gICAgbWFyZ2luLXRvcDogMTZweDtcbn1cblxuI2J1dHRvbi1yb3cge1xuICAgIGRpc3BsYXk6IGZsZXg7XG59XG5cbiNidXR0b24tc3BhY2VyIHtcbiAgICBmbGV4LWdyb3c6IDE7XG59XG5cbi5iYWNrLWJ1dHRvbiB7XG4gICAgbWFyZ2luOiA4cHg7XG4gICAgcGFkZGluZy1sZWZ0OiA4cHg7XG59XG5cbi5zdWJtaXQtYnV0dG9uIHtcbiAgICBtYXJnaW46IDhweDtcbn1cbiJdfQ== */");

/***/ }),

/***/ "./src/app/payment-review/payment-review.component.ts":
/*!************************************************************!*\
  !*** ./src/app/payment-review/payment-review.component.ts ***!
  \************************************************************/
/*! exports provided: PaymentReviewComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PaymentReviewComponent", function() { return PaymentReviewComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _core_alert_alert_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../core/alert/alert.service */ "./src/app/core/alert/alert.service.ts");
/* harmony import */ var _services_billing_options_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../services/billing-options.service */ "./src/app/services/billing-options.service.ts");
/* harmony import */ var _services_submission_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../services/submission.service */ "./src/app/services/submission.service.ts");






let PaymentReviewComponent = class PaymentReviewComponent {
    constructor(alertService, billingOptionsService, router, submissionService) {
        this.alertService = alertService;
        this.billingOptionsService = billingOptionsService;
        this.router = router;
        this.submissionService = submissionService;
        this.primaryInsuredEmailAddress = '';
        this.saveDetailChecked = true;
    }
    ngOnInit() {
        this.billingOptionsService.getBillingOptions()
            .subscribe(billingOptions => {
            this.primaryInsuredEmailAddress = billingOptions.primaryInsuredEmailAddress;
        });
        this.paymentDetails = this.billingOptionsService.getPaymentDetails();
    }
    isEmailRequired() {
        const today = new Date();
        const paymentDate = new Date(this.paymentDetails.paymentDate);
        return paymentDate > today;
    }
    submitWithPayment() {
        this.submissionService.submitWithPayment(this.paymentDetails.amount, this.billingOptionsService.getSelectedBillee().id, this.paymentDetails.email, this.paymentDetails.servicingFee, this.billingOptionsService.getSelectedPaymentPlan().name, this.toISODateString(this.paymentDetails.paymentDate), this.paymentDetails.tokenId, this.saveDetailChecked)
            .subscribe(res => {
            if (res.success) {
                this.paymentDetails.confirmationNumber = res.confirmationNumber;
                this.billingOptionsService.setPaymentDetails(this.paymentDetails);
                // noinspection JSIgnoredPromiseFromCall
                this.router.navigateByUrl('/receipt');
            }
            else {
                this.alertService.error(res.errors.join('\n'));
            }
        });
    }
    toISODateString(date) {
        const s = date.toISOString();
        return s.slice(0, s.indexOf('T'));
    }
};
PaymentReviewComponent.ctorParameters = () => [
    { type: _core_alert_alert_service__WEBPACK_IMPORTED_MODULE_3__["AlertService"] },
    { type: _services_billing_options_service__WEBPACK_IMPORTED_MODULE_4__["BillingOptionsService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _services_submission_service__WEBPACK_IMPORTED_MODULE_5__["SubmissionService"] }
];
PaymentReviewComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-payment-review',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./payment-review.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/payment-review/payment-review.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./payment-review.component.css */ "./src/app/payment-review/payment-review.component.css")).default]
    })
], PaymentReviewComponent);



/***/ }),

/***/ "./src/app/services/billing-options.service.ts":
/*!*****************************************************!*\
  !*** ./src/app/services/billing-options.service.ts ***!
  \*****************************************************/
/*! exports provided: BillingOptionsService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BillingOptionsService", function() { return BillingOptionsService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _model_payment_details__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../model/payment-details */ "./src/app/model/payment-details.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");






let BillingOptionsService = class BillingOptionsService {
    constructor(route, http) {
        this.route = route;
        this.http = http;
        this.billingOptionsUrl = 'api/billingOptions';
        this.token = '';
        if (this.route.snapshot.queryParamMap.has('token')) {
            this.token = this.route.snapshot.queryParamMap.get('token');
        }
        this.paymentDetails = new _model_payment_details__WEBPACK_IMPORTED_MODULE_3__["PaymentDetails"]();
    }
    getBillingOptions() {
        if (this.billingOptions) {
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(this.billingOptions);
        }
        return this.http.get(this.billingOptionsUrl);
    }
    getPaymentDetails() {
        return this.paymentDetails;
    }
    getPolicyNumber() {
        return this.policyNumber;
    }
    getSelectedBillee() {
        return this.selectedBillee;
    }
    getSelectedPaymentPlan() {
        return this.selectedPaymentPlan;
    }
    getToken() {
        return this.token;
    }
    setBillingOptions(billingOptions) {
        if (!this.billingOptions) {
            this.billingOptions = billingOptions;
        }
    }
    setPaymentDetails(paymentDetails) {
        this.paymentDetails = paymentDetails;
    }
    setSelectedBillee(billee) {
        this.selectedBillee = billee;
    }
    setSelectedPaymentPlan(paymentPlan) {
        this.selectedPaymentPlan = paymentPlan;
    }
    setPolicyNumber(policyNumber) {
        this.policyNumber = policyNumber;
    }
};
BillingOptionsService.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_5__["ActivatedRoute"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpClient"] }
];
BillingOptionsService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], BillingOptionsService);



/***/ }),

/***/ "./src/app/services/dynamic-script-loader.service.ts":
/*!***********************************************************!*\
  !*** ./src/app/services/dynamic-script-loader.service.ts ***!
  \***********************************************************/
/*! exports provided: DynamicScriptLoaderService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DynamicScriptLoaderService", function() { return DynamicScriptLoaderService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let DynamicScriptLoaderService = class DynamicScriptLoaderService {
    constructor() {
        this.scripts = {};
    }
    loadScript(name, url) {
        return new Promise((resolve, reject) => {
            if (!this.scripts[name] || !this.scripts[name].loaded) {
                this.scripts[name] = {
                    name, src: url
                };
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = this.scripts[name].src;
                if (script.readyState) { // IE
                    script.onreadystatechange = () => {
                        if (script.readyState === 'loaded' || script.readyState === 'complete') {
                            script.onreadystatechange = null;
                            this.scripts[name].loaded = true;
                            resolve(this.scripts[name]);
                        }
                    };
                }
                else { // Others
                    script.onload = () => {
                        this.scripts[name].loaded = true;
                        resolve(this.scripts[name]);
                    };
                }
                script.onerror = (error) => {
                    console.error('Error on loading script');
                    console.error(error);
                    this.scripts[name].loaded = false;
                    resolve(this.scripts[name]);
                };
                document.getElementsByTagName('head')[0].appendChild(script);
            }
            else {
                resolve(this.scripts[name]);
            }
        });
    }
};
DynamicScriptLoaderService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], DynamicScriptLoaderService);



/***/ }),

/***/ "./src/app/services/one-inc-http.service.ts":
/*!**************************************************!*\
  !*** ./src/app/services/one-inc-http.service.ts ***!
  \**************************************************/
/*! exports provided: OneIncHttpService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OneIncHttpService", function() { return OneIncHttpService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");




let OneIncHttpService = class OneIncHttpService {
    constructor(http) {
        this.http = http;
    }
    getPaymentSessionId() {
        const apiUrl = `/api/OneInc/getSessionId`;
        return this.http.get(apiUrl);
    }
    // This service is to save payment details for making one time payment
    saveOneIncPaymentDetails(data) {
        const apiUrl = `/api/savePaymentDetails`;
        return this.http.post(apiUrl, data, {
            observe: 'response'
        }).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(res => {
            return res.body;
        }));
    }
    // This service is to know the processing fee and total amount
    getConvenienceFee(data) {
        const apiUrl = `/api/getFee`;
        return this.http.post(apiUrl, data, {
            observe: 'response'
        }).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(res => {
            return res.body;
        }));
    }
};
OneIncHttpService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
OneIncHttpService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], OneIncHttpService);



/***/ }),

/***/ "./src/app/services/one-inc.service.ts":
/*!*********************************************!*\
  !*** ./src/app/services/one-inc.service.ts ***!
  \*********************************************/
/*! exports provided: OneIncService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OneIncService", function() { return OneIncService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _one_inc_http_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./one-inc-http.service */ "./src/app/services/one-inc-http.service.ts");
/* harmony import */ var _billing_options_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./billing-options.service */ "./src/app/services/billing-options.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _core_alert_alert_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../core/alert/alert.service */ "./src/app/core/alert/alert.service.ts");
/* harmony import */ var _dynamic_script_loader_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./dynamic-script-loader.service */ "./src/app/services/dynamic-script-loader.service.ts");









let OneIncService = class OneIncService {
    constructor(router, httpService, billingOptionsService, alertService, dynamicScriptLoader, oneIncService) {
        this.router = router;
        this.httpService = httpService;
        this.billingOptionsService = billingOptionsService;
        this.alertService = alertService;
        this.dynamicScriptLoader = dynamicScriptLoader;
        this.oneIncService = oneIncService;
        this.oneIncData = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](null);
        this.oneIncOpen = true;
        this.ONE_INC_ERROR = 'Sorry, we encountered a problem while processing your request. Please try again.';
    }
    setOneIncUrl(oneIncUrl) {
        this.oneIncUrl = oneIncUrl;
    }
    getUrl() {
        return `${this.oneIncUrl}Api/Api/Cdn/GenericModalV2/assets/js/PortalOne.js`;
    }
    initializeOneInc() {
        return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["from"])(this.dynamicScriptLoader.loadScript('OneInc', this.getUrl()))
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])((script) => {
            $('#portalOneContainer').portalOne();
            return script.loaded;
        }));
    }
    startOneIncProcess(paymentCategory, paymentAmount, paymentDate) {
        this.paymentDetails = this.billingOptionsService.getPaymentDetails();
        this.paymentDetails.name = this.billingOptionsService.getSelectedBillee().name;
        this.paymentDetails.policyNumber = this.billingOptionsService.getPolicyNumber();
        this.paymentDetails.paymentDate = paymentDate;
        this.paymentDetails.paymentCategory = paymentCategory;
        this.paymentDetails.amount = paymentAmount;
        this.httpService.getPaymentSessionId()
            .subscribe(response => {
            if (response && response.sessionId) {
                this.setOneIncUrl(response.oneIncUrl);
                this.initializeOneInc().subscribe(() => {
                    this.openOneIncModal(this.paymentDetails.paymentCategory, this.paymentDetails.name, this.paymentDetails.holderZip, this.paymentDetails.policyNumber, response.sessionId);
                });
            }
        }, () => {
            this.alertService.error(this.ONE_INC_ERROR);
        });
        this.oneIncData.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["takeWhile"])(() => this.oneIncOpen))
            .subscribe(res => {
            if (res) {
                console.log('oneIncData res', res);
                if (res.event === 'saveCanceled') {
                    return;
                }
                else if (res.event === 'saveComplete') {
                    console.log('save complete res', res);
                    this.paymentDetails = Object.assign({}, this.paymentDetails, res.data);
                    console.log('this.paymentDetails', this.paymentDetails);
                    this.onSaveComplete(this.paymentDetails);
                    this.oneIncOpen = false;
                }
                else if (res.event === 'error') {
                    this.alertService.error(this.ONE_INC_ERROR);
                }
            }
        });
    }
    onSaveComplete(paymentDetails) {
        this.httpService.saveOneIncPaymentDetails(paymentDetails)
            .subscribe(res => {
            console.log('saveOneIncPaymentDetails, res', res);
            if (res) {
                this.httpService.getConvenienceFee({
                    amount: this.paymentDetails.amount,
                    policyNumber: paymentDetails.policyNumber,
                    tokenId: paymentDetails.tokenId
                })
                    .subscribe(response => {
                    if (response) {
                        console.log('getConvenienceFee  res', response);
                        this.paymentDetails.servicingFee = response.serviceFee;
                        this.paymentDetails.totalPaymentAmount =
                            this.paymentDetails.amount + this.paymentDetails.servicingFee;
                        this.reviewPayment();
                    }
                });
            }
        }, error => {
            this.alertService.error(this.ONE_INC_ERROR, error.toString());
        });
    }
    reviewPayment() {
        this.billingOptionsService.setPaymentDetails(this.paymentDetails);
        this.router.navigateByUrl('/review');
    }
    openOneIncModal(paymentCategory, policyHolderName, billingZip, policyNum, sessionId) {
        $('#portalOneContainer').portalOne();
        const portalOne = $('#portalOneContainer');
        portalOne.data('portalOne')
            .savePaymentMethod({
            paymentCategory,
            billingZip,
            policyHolderName,
            referenceNumber: policyNum,
            confirmationDisplay: 'false',
            sessionId
        });
        this.oneIncEvents();
        this.oneIncSavedPaymentEvents();
    }
    oneIncEvents() {
        const scope = this;
        const portalOne = $('#portalOneContainer');
        portalOne.one('portalOne.load', () => {
            scope.setOneIncData('load', {});
        });
        portalOne.one('portalOne.unload', () => {
            scope.setOneIncData('unload', {});
        });
        portalOne.one('portalOne.error', (e, data) => {
            console.error(new Date() + ' portalOne.error.', data.Description, data.Details);
            scope.setOneIncData('error', data);
        });
    }
    oneIncSavedPaymentEvents() {
        const scope = this;
        const portalOne = $('#portalOneContainer');
        portalOne.one('portalOne.saveComplete', (x, data) => {
            scope.setOneIncData('saveComplete', data);
        });
        portalOne.one('portalOne.saveCanceled', () => {
            scope.setOneIncData('saveCanceled', {});
        });
    }
    setOneIncData(event, data) {
        const oneIncData = {
            event,
            data
        };
        this.oneIncData.next(oneIncData);
    }
};
OneIncService.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_6__["Router"] },
    { type: _one_inc_http_service__WEBPACK_IMPORTED_MODULE_4__["OneIncHttpService"] },
    { type: _billing_options_service__WEBPACK_IMPORTED_MODULE_5__["BillingOptionsService"] },
    { type: _core_alert_alert_service__WEBPACK_IMPORTED_MODULE_7__["AlertService"] },
    { type: _dynamic_script_loader_service__WEBPACK_IMPORTED_MODULE_8__["DynamicScriptLoaderService"] },
    { type: OneIncService }
];
OneIncService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], OneIncService);



/***/ }),

/***/ "./src/app/services/submission.service.ts":
/*!************************************************!*\
  !*** ./src/app/services/submission.service.ts ***!
  \************************************************/
/*! exports provided: SubmissionService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubmissionService", function() { return SubmissionService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");



let SubmissionService = class SubmissionService {
    constructor(http) {
        this.http = http;
        this.submitWithoutPaymentUrl = '/api/submitWithoutPayment';
        this.submitWithPaymentUrl = '/api/submitWithPayment';
    }
    submitWithoutPayment(billeeId, payPlan) {
        return this.http.post(this.submitWithoutPaymentUrl, { billeeId, payPlan });
    }
    submitWithPayment(amount, billeeId, email, fee, payPlan, paymentDate, paymentToken, savePaymentDetails) {
        return this.http.post(this.submitWithPaymentUrl, {
            amount,
            billeeId,
            email,
            fee,
            payPlan,
            paymentDate,
            paymentToken,
            savePaymentDetails
        });
    }
};
SubmissionService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
SubmissionService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], SubmissionService);



/***/ }),

/***/ "./src/app/success/success.component.css":
/*!***********************************************!*\
  !*** ./src/app/success/success.component.css ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".message {\n    display: flex;\n    align-items: center;\n}\n\n.message-text {\n    margin-left: 6px;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvc3VjY2Vzcy9zdWNjZXNzLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxhQUFhO0lBQ2IsbUJBQW1CO0FBQ3ZCOztBQUVBO0lBQ0ksZ0JBQWdCO0FBQ3BCIiwiZmlsZSI6InNyYy9hcHAvc3VjY2Vzcy9zdWNjZXNzLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIubWVzc2FnZSB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xufVxuXG4ubWVzc2FnZS10ZXh0IHtcbiAgICBtYXJnaW4tbGVmdDogNnB4O1xufVxuIl19 */");

/***/ }),

/***/ "./src/app/success/success.component.ts":
/*!**********************************************!*\
  !*** ./src/app/success/success.component.ts ***!
  \**********************************************/
/*! exports provided: SuccessComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SuccessComponent", function() { return SuccessComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let SuccessComponent = class SuccessComponent {
    constructor() { }
    ngOnInit() {
    }
};
SuccessComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-success',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./success.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/success/success.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./success.component.css */ "./src/app/success/success.component.css")).default]
    })
], SuccessComponent);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! hammerjs */ "./node_modules/hammerjs/hammer.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(hammerjs__WEBPACK_IMPORTED_MODULE_5__);






if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /appbuild/client/src/main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map